import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import {
  TextField, Button, Grid, Typography, CircularProgress, Box, Card, AlertColor, Alert, CardHeader, CardContent
} from '@mui/material';



import { IChangeNewPassword, IChangePassword } from 'shared/types';
import { useSessionActions, useSessionUser } from 'shared/store/session';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { InputError } from 'shared/components';
import { CrtlAcessService } from 'shared/services/crtlAcess/crtlAcessService';

const validationSchema = yup.object({

  password: yup.string().required(),
  ant_password: yup.string().required()
  
});
export const ChangeNewPassword: React.FC = () => {
  const userActions = useSessionActions();

  const [isLoading, setIsLoading] = useState(false);
  const user = useSessionUser();
  const [alert, setAlert] = useState<null | { text: string; type: AlertColor }>(null);
  const { t } = useTranslation();

  const navigate = useNavigate();

  const { register, handleSubmit, formState: { errors }, } = useForm({
    resolver: yupResolver(validationSchema)
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [msgErro] = useState({ username: '', password: '', ant_password: '' });

  const onSubmit = async (data: IChangeNewPassword) => {

    setIsSubmitting(true);
    CrtlAcessService.changeNewPw(Number(user?.id), String(data.password), String(data.ant_password))
      .then((result) => {
        if (result instanceof Error) {
          setIsSubmitting(false);
          setAlert({
            text: result.message,
            type: 'error',
          });
        } else {
          setIsSubmitting(false); 
          setAlert({
            text: t('messages.success.newpassword'),
            type: 'success',
          });
        }
        // setTimeout(() => {
        //   navigate('/');
        // },1000);
      });
  };  

  return (
    <Box component="form"
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        width: '550px',
        margin: '0 auto',
      }}
      noValidate autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
      <Card sx={{ marginTop: '80px' }}>
        <CardHeader sx={{ textAlign: 'center', padding: '1px', color: '#153085' }} title={t('pages.navbar.newpassworduser')} />

        <CardContent>
          <div>
            {alert ? (
              <>
                <Grid item xs={12}>
                  <Alert severity={alert.type} onClose={() => setAlert(null)}>
                    {alert.text}
                  </Alert>
                </Grid>
              </>
            ) : ''}
          </div>
          <Box
            sx={{
              
              flex: '1 1 auto',
              display: 'flex',
              flexDirection: 'column',
              gap: 4,
              alignItems: 'center',
              justifyContent: 'stretch',
              pt: 6,
              px: 4,
            }}
          >
            {isLoading && <CircularProgress />}

            <>
              <CardContent>
                <div>
                  {alert ? (
                    <>
                      <Grid item xs={12}>
                        <Alert severity={alert.type} onClose={() => setAlert(null)}>
                          {alert.text}
                        </Alert>
                      </Grid>
                    </>
                  ) : (
                    ''
                  )}
                  <TextField
                    error={errors?.ant_password?.type ? true : false}
                    fullWidth
                    id='username'
                    type='password'
                    label={`${t('pages.login.senhaAtual')} *`}
                    disabled={isSubmitting}
                    helperText={errors?.ant_password?.type ? msgErro.ant_password : ''}
                    {...register('ant_password')}
                    sx={{ marginTop: '1rem', marginBottom: '0' }}
                  />
                  {errors?.ant_password?.type && <InputError type={errors.ant_password.type} field='ant_password' />}
                  <TextField
                    error={errors?.password?.type ? true : false}
                    fullWidth
                    id='username'
                    type='password'
                    label={`${t('pages.login.newpassword')} *`}
                    disabled={isSubmitting}
                    helperText={errors?.password?.type ? msgErro.password : ''}
                    //{...register('username')}
                    sx={{ marginTop: '1rem', marginBottom: '0' }}
                  />
                  {errors?.password?.type && <InputError type={errors.password.type} field='password' />}
                  <TextField
                    error={errors?.password?.type ? true : false}
                    fullWidth
                    id='password'
                    type='password'
                    label={`${t('pages.login.confirmNewpassword')} *`}
                    disabled={isSubmitting}
                    helperText={errors?.password?.type ? msgErro.password : ''}
                    {...register('password')}
                    sx={{ marginTop: '1rem', marginBottom: '0' }}
                  />
                  {errors?.password?.type && <InputError type={errors.password.type} field='password' />}
                </div>

                <Card sx={{ minWidth: 300, Width: 400, background: 'lightblue', marginTop: '1rem' }} color='blue'>
                  <CardContent>
                    <Typography sx={{ fontSize: 14 }} gutterBottom>
                      {t('pages.changePassword.passwordMessage1')}
                    </Typography>
                    <Typography sx={{ fontSize: 14 }} gutterBottom>
                      {t('pages.changePassword.passwordMessage2')}
                    </Typography>
                    <Typography sx={{ fontSize: 14 }} gutterBottom>
                      {t('pages.changePassword.passwordMessage3')}
                    </Typography>
                    <Typography sx={{ fontSize: 14 }} gutterBottom>
                      {t('pages.changePassword.passwordMessage4')}


                    </Typography>
                  </CardContent>

                </Card>
              </CardContent>
              <Grid container spacing={2}>
                <Grid container item xs={6}>
                  <Button
                    fullWidth
                    size="large"
                    variant="contained"
                    color="primary"
                    onClick={() => navigate('/')}
                  >
                    {t('components.actions.voltar')}
                  </Button>
                </Grid>
                <Grid container item xs={6}>
                  <Button
                    fullWidth
                    size="large"
                    variant="contained"
                    type="submit"
                    color="primary"
                  >
                    {t('pages.organizationSeletion.confirm')}
                  </Button>
                </Grid>
              </Grid>

            </>

          </Box>
        </CardContent>

      </Card>
    </Box>
  );
};